import React from 'react'
import { Box, Typography, Link } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import { AnnouncementResponse } from '@professocialApi/professocial-core-frontend-api/models/AnnouncementResponse'

export interface AnnouncementHeaderProps {
  announcement: AnnouncementResponse;
}

/**
 * Renders a banner header for an active announcement.
 *
 * @param props - Announcement header properties.
 */
const AnnouncementHeader: React.FC<AnnouncementHeaderProps> = ({ announcement }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      bgcolor="primary.main"
      color="primary.contrastText"
      px={3}
      py={2}
    >
      {/* Left Section: Info Icon and Headline */}
      <Box display="flex" alignItems="center" flex="0 0 15%" maxWidth="15%">
        <InfoIcon sx={{ marginRight: 1, fontSize: 32 }} />
        <Typography variant="h6" fontWeight="bold">
          {announcement.headline}
        </Typography>
      </Box>

      {/* Right Section: Header Text with Inline Link */}
      <Box flex="1" pl={3} textAlign="left">
        <Typography variant="body1">
          <span
            dangerouslySetInnerHTML={{
              __html: announcement.headerText || '',
            }}
          />
          {announcement.linkUrl && announcement.linkText && (
            <>
              {' '}
              <Link
                href={announcement.linkUrl}
                color="inherit"
                sx={{ fontWeight: 'bold' }}
                target="_blank"
                rel="noopener"
              >
                {announcement.linkText}
              </Link>
            </>
          )}
        </Typography>
      </Box>
    </Box>
  )
}

export default AnnouncementHeader
